import React, { useEffect, useState, useContext } from 'react';
import { Form, Input, DatePicker, Select } from 'antd';
import { GlobalContext } from '../../../../../context/globalContext.js';

const { Option } = Select;

const CArticuloSupermercadoEmpresa = ({form}) => {
  const [unidades, setUnidades] = useState([]);
  const { categorias } = useContext(GlobalContext);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/unidad-medida-super`) // ejemplo: nueva ruta
      .then(res => res.json())
      .then(setUnidades)
      .catch(err => console.error('Error al cargar unidades de medida:', err));
  }, []);

  return (
    <>
      <Form.Item name="contenido_neto" label="Contenido Neto">
        <Input />
      </Form.Item>

      <Form.Item name="unidad_medida" label="Unidad de Medida">
        <Select placeholder="Seleccione una unidad">
          {unidades.map((u) => (
            <Option key={u.ums_id} value={u.ums_id}>{u.ums_nombre}</Option>
          ))}
        </Select>
      </Form.Item>
    </>
  );
};

export default CArticuloSupermercadoEmpresa;